class ShippingMethods extends HTMLElement {
    constructor() {
        super();
        const currentSelect = this.querySelector(".select-box__current");
        currentSelect?.addEventListener("click", this.handleClick);
        currentSelect?.addEventListener("blur", this.handleBlur);
        this.querySelectorAll(".ship-method").forEach((shipMethodContainer) => {
            shipMethodContainer.addEventListener(
                "click",
                this.handleShipMethodClick
            );
        });
        this.querySelectorAll(".select-box__input").forEach((shipLocation) => {
            shipLocation.addEventListener("click", this.handleLocationClick);
        });
        this.checkShipping();
    }

    checkShipping = async () => {
        const cart = await fetch("/cart.js").then((res) => res.json());
        const shipMethod = JSON.parse(cart.attributes["shipMethod"] ?? "null");
        if (shipMethod === null) {
            await this.changeCartAttributes();
            this.checkShipping();
            return;
        }
        const selector = this.querySelector(
            `input.ship-method[value='${shipMethod.methodType}']`
        );
        if (shipMethod.methodType === "local-pickup" && selector) {
            selector.checked = true;
            this.querySelector("#ship_store").classList.remove("hidden-select");
            this.querySelectorAll(".select-box__input").forEach((input) => {
                const address = JSON.parse(input.value);
                if (
                    address.countryCode === shipMethod.address.countryCode &&
                    address.address === shipMethod.address.address &&
                    address.city === shipMethod.address.city &&
                    address.zipCode === shipMethod.address.zipCode &&
                    address.shop === shipMethod.address.shop &&
                    address.stateCode === shipMethod.address.stateCode
                ) {
                    input.checked = true;
                }
            });
        } else if (shipMethod.methodType !== "ship-address") {
            this.querySelector(`input.ship-method`)?.click();
        }
    };

    handleClick = () => {
        const list = this.querySelector(".select-box__list");
        if (list.classList.contains("active-select-box")) {
            list.classList.remove("active-select-box");
        } else {
            list.classList.add("active-select-box");
        }
    };

    handleBlur = () => {
        const list = this.querySelector(".select-box__list");
        setTimeout(() => {
            list.classList.remove("active-select-box");
        }, 100);
    };

    handleLocationClick = async (e) => {
        const el = e.currentTarget;
        const address = JSON.parse(el.value);
        const shipMethod = {
            methodType: "local-pickup",
            address: address,
        };
        const changeResponse = await this.changeCartAttributes(shipMethod);
    };

    handleShipMethodClick = async (e) => {
        const el = e.currentTarget;
        const storeListContainer = this.querySelector("#ship_store");
        const shipMethod = {
            methodType: "",
            address: undefined,
        };
        if (el.value === "local-pickup") {
            if (storeListContainer?.classList.contains("hidden-select")) {
                storeListContainer?.classList.remove("hidden-select");
            }
            const address = JSON.parse(
                this.querySelector(".select-box__input:checked").value
            );
            shipMethod.methodType = "local-pickup";
            shipMethod.address = address;
        } else {
            if (!storeListContainer?.classList.contains("hidden-select")) {
                storeListContainer?.classList.add("hidden-select");
            }
            shipMethod.methodType = "ship-address";
        }
        const changeResponse = await this.changeCartAttributes(shipMethod);
    };

    changeCartAttributes = async (shipMethod = null) => {
        if (shipMethod === null) {
            shipMethod = {
                methodType: "ship-address",
                address: undefined,
            };
        }
        const shipMethodParse = JSON.stringify(shipMethod);
        const formData = new FormData();
        formData.append("attributes[shipMethod]", shipMethodParse);
        try {
            const fetchResponse = await fetch(
                window.Shopify.routes.root + "cart/update.js",
                {
                    method: "POST",
                    body: formData,
                }
            ).then((res) => res.json());
            if (fetchResponse.attributes["shipMethod"] === shipMethodParse) {
                return { state: true };
            } else {
                return { state: false };
            }
        } catch (err) {
            return { state: false };
        }
    };
}
customElements.define("shipping-methods-container", ShippingMethods);

class NoShippingMethods extends HTMLElement {
    constructor() {
        super();
        (async () => {
            const response = await this.changeCartAttributes();
            console.log("response", response);
        })();
    }

    changeCartAttributes = async () => {
        const shipMethod = {
            methodType: "ship-address",
            address: undefined,
        };
        const shipMethodParse = JSON.stringify(shipMethod);
        const formData = new FormData();
        formData.append("attributes[shipMethod]", shipMethodParse);
        try {
            const fetchResponse = await fetch(
                window.Shopify.routes.root + "cart/update.js",
                {
                    method: "POST",
                    body: formData,
                }
            ).then((res) => res.json());
            if (fetchResponse.attributes["shipMethod"] === shipMethodParse) {
                return { state: true };
            } else {
                return { state: false };
            }
        } catch (err) {
            return { state: false };
        }
    };
}

customElements.define("no-shipping-methods-container", NoShippingMethods);
